import { createEntitySchemas } from '../../../utils/normalize'

export const USER_PUBLIC_DATA = 'usersPublicData'
export const userPublicDataSchemas = createEntitySchemas(USER_PUBLIC_DATA)
